import React from "react";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import styles from "../Scrollarea.module.css";

const VendorTransaction = () => {
  const { mainDashboardOfPayment } = useSelector(
    (state) => state.vendorPayment
  );

  const { clusterPaymentList } = mainDashboardOfPayment || {};

  const earningsData = {
    totalEarnings: "45,70,800",
    cardNumber: "2468",
    bankName: "State Bank of India",
  };

  const formatDateShort = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="p-2">
      <div className="flex gap-4">
        {/* Fixed Cards Section */}
        <div className=" flex-shrink-0 pr-4 border-r-2 border-dashed">
          <h2 className="text-2xl font-semibold text-black mb-2">Earning</h2>
          <div className="relative w-[315px] h-[184px]  text-white rounded-3xl shadow-lg">
            <img
              src="/assests/vendorPortalImages/paymentCard.webp"
              alt="paymentcard"
              className=" object-cover w-full h-full absolute inset-0"
            />
            <div className="p-6 pb-2 w-full flex justify-between relative">
              <h3 className="text-sm font-normal opacity-90">Total Earnings</h3>
              {/* <img
                src="/assests/vendorPortalImages/paymentChip.webp"
                alt="payment chip"
                className=" w-9 h-5 "
              /> */}
            </div>
            <div className="px-4 pb-4 space-y-2">
              <div className="text-3xl font-semibold relative">
                ₹{" "}
                {mainDashboardOfPayment?.totalVendorPayment?.toLocaleString(
                  "en-IN"
                )}
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="flex gap-1"></div>
                  <span className="text-sm opacity-90 text-center">
                    {`* * * * * * * * 2 4 6 8`}
                  </span>
                </div>
                {/* <CreditCardIcon className="w-6 h-6 opacity-80" /> */}
              </div>
              <div className=" relative">
                <div className="text-xs opacity-75 uppercase tracking-wide">
                  BANK
                </div>
                <div className="text-sm font-medium">
                  {`State Bank of India`}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scrollable Recent Transactions Section */}
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl font-semibold text-black mb-2">
            Recent Transactions
          </h2>
          <div
            className={`${styles.scrollContainerForTransaction} flex gap-4 overflow-x-auto`}
          >
            {Array.isArray(clusterPaymentList) &&
            clusterPaymentList.length > 0 ? (
              clusterPaymentList.map((transaction) => (
                <div
                  key={transaction?.clusterId}
                  className="relative flex-shrink-0 w-[360px] h-[184px] overflow-hidden bg-white border border-gray-200 rounded-3xl shadow-sm"
                >
                  <img
                    src="/assests/vendorPortalImages/paymentCard1.webp"
                    alt="paymentcard1"
                    className=" object-cover w-full h-full absolute inset-0"
                  />
                  <div className="p-4 relative">
                    <div className="flex items-center justify-between mb-3">
                      <span className="text-xs text-white bg-[#96A0FF] px-2 py-1 rounded-full">
                        {transaction?.paymentDate &&
                          new Date(transaction.paymentDate).toLocaleDateString(
                            "en-GB",
                            {
                              day: "numeric",
                              month: "long",
                              year: "numeric",
                            }
                          )}
                      </span>
                    </div>

                    <h3 className="font-medium text-base mb-3">
                      {transaction?.productType}
                    </h3>

                    <div className="flex items-center text-3xl font-bold text-[#7581FF] gap-2 mb-2">
                      <AddIcon fontSize="large" className="w-4 h-4" />
                      <span className="  ">
                        ₹{transaction?.totalAmountPaid.toLocaleString("en-IN")}
                      </span>
                    </div>

                    <div className="flex items-center justify-between border-t-2 border-dashed py-1">
                      <div className="flex items-center gap-2">
                        <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden">
                          <img
                            src={
                              transaction.avatar ||
                              "/assests/vendorPortalImages/maleEmoji2.webp"
                            }
                            alt={transaction?.user}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <span className="text-sm text-gray-600">
                          {transaction?.user || `Abhimanyu Chauhan`}
                        </span>
                      </div>
                      <span className="text-xs text-gray-500">
                        {formatDateShort(transaction?.jobStartingDate)} -{" "}
                        {formatDateShort(transaction?.jobCompletionDate)}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-gray-500 text-sm py-6">
                No recent transactions found.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorTransaction;
